<script setup>
import { RouterView } from 'vue-router'
import ToastContainer from '@/components/ui/ToastContainer.vue'
</script>

<template>
  <a
    href="#main-content"
    class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-coral-600 focus:px-4 focus:py-2 focus:text-cream-100 focus:outline-none"
  >
    Saltar al contenido
  </a>
  <div id="main-content" tabindex="-1">
    <RouterView />
  </div>
  <ToastContainer />
</template>
